// local
import Api from '.';

export function list() {
    return Api.get('/cylinder');
}
